import * as $ from 'jquery';
import { SVG } from '@svgdotjs/svg.js';
import { declOfNum, numberFormat } from '../helpers'
import { initCompass } from "../helpers/helpers";

export default class RoomSelect {
    constructor($block) {
        this.$block = $block;
        this.$drawing = $block.find('[data-drawing]');
        this.$drawingTransparent = $block.find('[data-drawing_transparent]');
        this.$locationDrawing = $block.find('#map_drawing');

        if (!this.$drawing.length) return false;

        this.desktop = null;

        this.items = JSON.parse(this.$drawingTransparent.attr('data-items'));
        this.locatonItems = JSON.parse(this.$locationDrawing.attr('data-items'));

        this.drawingItems = [];
        this.drawingItemsTransparent = [];
        this.drawingLocationItems = [];

        this.width = this.$drawingTransparent.attr('data-width') || 650;
        this.height = this.$drawingTransparent.attr('data-height') || 650;

        this.drawingOptions = {
            id: this.$drawing.attr('id'),
            idTransparent: this.$drawingTransparent.attr('id'),
            image: this.$drawing.attr('data-image'),
            colorBase: 'rgba(255, 77, 0, 0.3)',
            colorFill: 'rgba(255, 255, 255, 0.3)',
            colorNoFill: 'rgba(0,0,0,0)',
            colorDisabled: 'rgba(133, 133, 133, 0.4)',
            fillOptions: ['246, 184, 53', '255, 92, 48', '206, 223, 231'],
            width: this.width,
            height: this.height
        }

        this.init();
    }

    init() {
        $('#header').addClass('header-inner');
        this.$popupInfo = this.createPopup();
        this.$popupInfoContent = this.$popupInfo.find('.content-popup-room');

        this.draw = this.drawingInit();
        this.drawTransparent = this.drawingTransparentInit();
        //this.drawLocation = this.locationDrawingInit();

        this.addDrawingItems();
        //this.addLocatonDrawingItems();
        initCompass();
        $(window)
            /*  .on('mousemove', (e) => {    Убрать обработчик с попапа для появления снизу
                 this.setPopupPosition(e);
             }) */
            .on('resize', (e) => {
                this.initEventsHandler();
            });

        // закрытие тултипа
        $('body').on('click', '[data-close-popup-info]', () => {
            this.hidePopup();
            return false;
        });

        this.initEventsHandler();
    }

    locationDrawingInit() {
        const draw = SVG().addTo('#map_drawing');
        draw.viewbox(0, 0, 260, 390);
        const image = draw.image(this.$locationDrawing.data('image'));

        image.size('100%', '100%').move(0, 0);

        return draw;
    }


    /**
     * Обработчик событий холста
     * для десктопа и мобильной версии разные события
     */
    initEventsHandler() {
        const desktop = this.isDesktop();
        if (desktop !== this.desktop) this.desktop = desktop;

        this.$block.off('mouseenter', '.item');
        this.$block.off('mouseleave', '.item');
        this.$block.off('click', '.item');


        this.drawingItemsTransparent.forEach((item, i) => {
            const initItem = this.drawingItems[i];

            item.off('click');
            item.off('mouseenter');
            item.off('mouseleave');

            if (this.desktop) {
                item
                    .on('mouseenter', () => {
                        this.handlerMouseenter(initItem);
                    })
                    .on('mouseleave', () => {
                        this.handlerMouseleave(initItem);
                    })
                    .on('click', () => {
                        this.handlerClick(initItem);
                    });

            } else {
                item.on('click', () => {
                    this.handlerClickMobile(initItem);
                    return false;
                });
            }

        })

        this.drawingLocationItems.forEach((item, i) => {
            item.off('click');

            item
                .on('click', () => {
                    this.handlerClick(item);
                });
        })

    }

    drawingInit() {
        const draw = SVG().addTo(`#${this.drawingOptions.id}`);

        draw.viewbox(0, 0, this.drawingOptions.width, this.drawingOptions.height);

        const image = draw.image(this.drawingOptions.image);
        image.size('100%', '100%').move(0, 0);

        return draw;
    }

    drawingTransparentInit() {
        const drawTransparent = SVG().addTo(`#${this.drawingOptions.idTransparent}`);

        drawTransparent.viewbox(0, 0, this.drawingOptions.width, this.drawingOptions.height);

        const image = drawTransparent.image(this.drawingOptions.image);
        image.size('100%', '100%').move(0, 0);

        return drawTransparent;
    }

    /**
     * Добавлеине навигационных элементов секций
     * @returns {boolean}
     */
    addDrawingItems() {
        for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            if (!item.id) continue;

            this.addItemSVG(item);
        }
    }

    addLocatonDrawingItems() {
        for (let i = 0; i < this.locatonItems.length; i++) {
            const item = this.locatonItems[i];
            if (!item.id) continue;

            this.addLocationItemSVG(item);
        }
    }

    addLocationItemSVG(item = {}) {
        const {
            id = null,
            href = '',
            coords = '',
        } = item;

        //this.drawingLocationItems[id] = this.drawLocation.polygon(coords);
        this.drawingLocationItems[id].fill(this.drawingOptions.colorNoFill);

        //this.drawingLocationItems[id].addClass('pointer')
        this.drawingLocationItems[id].data({
            id,
            href,
            coords
        });
    }

    /**
     * Добавление SVG элемента на холст
     * @param {Object} item - данные о секции
     */
    addItemSVG(item = {}) {
        const {
            id = null,
            href = '',
            name = '',
            sold = '',
            area = '',
            price = '',
            rooms = '',
            coords = '',
            cellNumber = '',
        } = item;

        this.drawingItems[id] = this.draw.polygon(coords);
        this.drawingItemsTransparent[id] = this.drawTransparent.polygon(coords);
        this.drawingItemsTransparent[id].fill(this.drawingOptions.colorNoFill);

        if (sold == '1') {
            this.drawingItems[id].fill(this.drawingOptions.colorDisabled);
        } else {
            this.drawingItems[id].fill(`rgba(${this.drawingOptions.fillOptions[2]}, 0.5 )`);
        }

        this.drawingItemsTransparent[id].style('cursor', 'pointer');
        this.drawingItemsTransparent[id].data({
            id,
            href,
            coords,
            name,
            sold,
            area,
            price,
            rooms,
            cellNumber
        });
        this.drawingItems[id].data({
            id,
            href,
            coords,
            name,
            sold,
            area,
            price,
            rooms,
            cellNumber
        });
    }


    /**
     * Обработчик наведения на объект
     * @param {Object} item - svg.js объект
     */
    handlerMouseenter(item) {
        const sold = item.data('sold');

        if (sold == '1') {
            item.fill(this.drawingOptions.colorDisabled);
        } else {
            item.fill(`rgba(${this.drawingOptions.fillOptions[2]}, 0.8)`);
        }

        this.setDataPopup(item);
        this.showPopup();
    }

    /**
     * Обработчик ухода курсора с объекта
     * @param {Object} item - svg.js объект
     */
    handlerMouseleave(item) {
        const sold = item.data('sold');

        if (sold == '1') {
            item.fill(this.drawingOptions.colorDisabled);
        } else {
            item.fill(`rgba(${this.drawingOptions.fillOptions[2]}, 0.5)`);
        }

        this.hidePopup();
    }

    /**
     * Обработчик клика на объект - десктоп
     * @param {Object} item - svg.js объект
     */
    handlerClick(item) {
        window.location.href = item.data('href');
        return false;
    }

    /**
     * Обработчик клика на объект - мобильные устройства
     * @param {Object} item - svg.js объект
     */
    handlerClickMobile(item) {
        // открываем попап
        this.setDataPopup(item);
        this.showPopup();
    }

    /**
     * Определение десктопа
     * @returns {boolean}
     */
    isDesktop() {
        return (window.innerWidth > 1000);
    }

    /**
     * Позиционирование тултипа
     * @param {Object} e - объект с параметрами курсора
     */
    setPopupPosition(e) {
        const mouseX = e.clientX + document.body.scrollLeft;
        const mouseY = e.clientY + document.body.scrollTop;

        let top = mouseY + 25;
        let left = mouseX + 15;
        const tooltipHeight = this.$popupInfo.height() + 30;
        const tooltipWidth = this.$popupInfo.width() + 15;

        //условия, чтобы тултип не ушел за вьюпорт
        if ((mouseY + tooltipHeight) > $(window).height()) {
            top = top - tooltipHeight;
        }

        if ((mouseX + tooltipWidth) > $(window).width()) {
            left = left - tooltipWidth;
        }

        const style = {
            left: '40%',
            top: `${top}px`
        };
        this.$popupInfo.css(style);
    }

    /**
     * Показ тултипа
     */
    showPopup() {
        if (this.desktop) {
            this.$popupInfo.addClass('show-room-popup');
            setTimeout(() => {
                this.$popupInfo.find('#popup-number').addClass('popup-show-number');
            }, 50);
            setTimeout(() => {
                this.$popupInfo.find('#popup-rooms').addClass('popup-show-rooms');
            }, 100);
            setTimeout(() => {
                this.$popupInfo.find('#popup-square').addClass('popup-show-square');
            }, 150);
            setTimeout(() => {
                this.$popupInfo.find('#popup-cost').addClass('popup-show-cost');
            }, 200);
            return false;
        }
        this.$popupInfo.addClass('show-room-popup');
    }

    /**
     * Закрытие тултипа
     */
    hidePopup() {
        if (this.desktop) {
            this.$popupInfo.find('#popup-number').removeClass('popup-show-number');
            setTimeout(() => {
                this.$popupInfo.find('#popup-rooms').removeClass('popup-show-rooms');
            }, 50);
            setTimeout(() => {
                this.$popupInfo.find('#popup-square').removeClass('popup-show-square');
            }, 100);
            setTimeout(() => {
                this.$popupInfo.find('#popup-cost').removeClass('popup-show-cost');
            }, 150);
            setTimeout(() => {
                this.$popupInfo.removeClass('show-room-popup');
            }, 400);

            return false;
        }
        this.$popupInfo.removeClass('show-room-popup');
        this.clearPopup();
    }

    /**
     * Создание тултипа
     * @return {HTMLElement} созданный тултип
     */
    createPopup() {
        $('body').append(`
            <div id="popup_info" class="popup-info-room room-popup show-effect-room-popup">
                <div class="content-popup-room"></div>
            </div>
        `);

        return $('#popup_info');
    }

    /**
     * Добавление данных в тултип
     * @param {Object} item - svg.js объект
     */
    setDataPopup(item = {}) {
        const href = item.data('href');
        const name = item.data('name');
        const rooms = item.data('rooms');
        const area = item.data('area');
        const price = item.data('price');
        const sold = item.data('sold') || '0';
        const cellNumber = item.data('cellNumber');

        const roomName = ['Студия', '1 комн.', '2 комн.'];

        let priceBlock = '';
        if (sold == 1) priceBlock = `<p class="text price"> Квартира продана</p>`;

        const headHTML = `
            <div class="head flexOrientation">
                <div class="popup-text number" id="popup-number">
                №${cellNumber}
                <span class="popup-onlyText ">Квартира</span>
                </div>
                <div class="popup-text rooms" id="popup-rooms">
                ${name}
                <span class="popup-onlyText">${declOfNum(name, ['Комната', 'Комнаты', 'Комнат'])}</span>
                </div>
                <div class="popup-text square" id="popup-square">
                ${area}
                <span class="popup-onlyText">Площадь, м2</span>
                </div>
                <div class="popup-text cost" id="popup-cost">
                <nobr>${numberFormat(price)} ₽</nobr>
                <span class="popup-onlyText">Стоимость</span>
                </div>
            </div>
        `;

        let buttonHTML = `
            <div class="text-align-center hide-desktop">
                <a href="${href}" class="button orange no-margin-horizontal style-for-button">Продолжить</a>
            </div>
        `;

        const popupHTML = headHTML + buttonHTML;
        this.$popupInfoContent.html(popupHTML);
    }

    /**
     * Очистка HTML тултипа
     */
    clearPopup() {
        this.$popupInfoContent.html('');
    }
}